module.exports = __webpack_public_path__ + "img/betterfield-logo.757d68ab.png";